import { SECONDS_IN_MINUTE, MILLISECONDS_IN_SECOND } from '@/common/constants/time.constants';

export const OPENSTACK_AUTH_RECEIPT_HEADER = 'Openstack-Auth-Receipt';

export const SCOPED_TOKEN_HEADER_NAME = 'X-Auth-Token';

export const AUTH_RECEIPT_EXPIRATION_TIME = 5 * SECONDS_IN_MINUTE * MILLISECONDS_IN_SECOND;
